import { getSelectedValue } from "../Filter/GetSelectedValue";
// import { parse } from "query-string";

interface Row<TValues = any> {
  id: string;
  path: string; // same as id
  index: number;
  values: TValues;
  depth: number;
}

type ValueSelectorFunction<TValue = any> = (value: TValue) => any;

type SortFunction<TRowValues = any> = (
  rowA: Row<TRowValues>,
  rowB: Row<TRowValues>,
  columnId: string,
  valueSelector?: ValueSelectorFunction
) => number;

const getRowValueByColumnId = (
  row: Row,
  columnId: string,
  valueSelector?: ValueSelectorFunction
) => {
  return getSelectedValue(row.values[columnId], valueSelector);
};

export const sortPriority: SortFunction = (rowA, rowB, columnId, valueSelector) => {
  const a = getRowValueByColumnId(rowA, columnId, valueSelector);
  const b = getRowValueByColumnId(rowB, columnId, valueSelector);
  let numA = 0;
  let numB = 0;

  if (a) {
    numA = parseInt(a, 10);
  }

  if (b) {
    numB = parseInt(b, 10);
  }

  return numB - numA;
};
